import * as React from 'react';
import { useRouterState } from '@tanstack/react-router';

import { mainNavigation } from '@/config/navigation';
import { useFilteredNavigation } from '@/hooks/useFilteredNavigation';
import { NavMain } from '@/components/nav-main';
import { NavActions } from '@/components/nav-actions';
import { NavUser } from '@/components/nav-user';
import { OrgSwitcher } from '@/components/org-switcher';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const router = useRouterState();
  const currentPath = router.location.pathname;
  const filteredNavigation = useFilteredNavigation(mainNavigation);

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <OrgSwitcher />
      </SidebarHeader>

      <SidebarContent>
        <NavMain groups={filteredNavigation} currentPath={currentPath} />
      </SidebarContent>

      <SidebarFooter>
        <NavActions />
        <NavUser />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
